class SiteCardPositionerMobile
    implements ISiteCardPositioner {

    private _container: SiteContainer;

    constructor(container: SiteContainer, cards: ISiteCard[]) {
        this._container = container.addClass("mobile");
    }

    addCard(card: ISiteCard) {
        // Do nothing, handled by CSS
    }
    replaceCard(oldCard: ISiteCard, newCard: ISiteCard): void {
        // Do nothing, handled by CSS
    }
    removeCard(card: ISiteCard) {
        // Do nothing, handled by CSS
    }
    redraw() {
        // Do nothing, handled by CSS
    }
    resize(position: DOMRect) {
        if(position.width <= 500) {
            if(!this._container.containsClass("mobile-small")) {
                this._container
                    .removeClass("mobile-large")
                    .addClass("mobile-small");
            }
        } else {
            if(!this._container.containsClass("mobile-large")) {
                this._container
                    .removeClass("mobile-small")
                    .addClass("mobile-large");
            }
        }
    }
    destruct() {
        // Remove it
        this._container
            .removeClass("mobile")
            .removeClass("mobile-large")
            .removeClass("mobile-small");
    }
}